const GOOGLE_CONSENT_STORAGE_KEY = 'cookiesAccepted';

function getGoogleConsentPayload(granted) {
	const consentState = granted ? 'granted' : 'denied';

	return {
		analytics_storage: consentState,
		ad_storage: consentState,
		ad_user_data: consentState,
		ad_personalization: consentState,
	};
}

function ensureGoogleTagQueue() {
	if (typeof window === 'undefined') return null;

	window.dataLayer = window.dataLayer || [];
	window.gtag = window.gtag || function () {
		window.dataLayer.push(arguments);
	};

	return window.gtag;
}

function updateGoogleConsent(granted) {
	const gtag = ensureGoogleTagQueue();
	if (!gtag) return false;

	gtag('consent', 'update', getGoogleConsentPayload(granted));
	return true;
}

function storeGoogleConsent(granted) {
	try {
		sessionStorage.setItem(GOOGLE_CONSENT_STORAGE_KEY, String(granted));
		return true;
	} catch (error) {
		return false;
	}
}

export function getStoredGoogleConsent() {
	try {
		const storedConsent = sessionStorage.getItem(GOOGLE_CONSENT_STORAGE_KEY);

		if (storedConsent === 'true') return true;
		if (storedConsent === 'false') return false;
	} catch (error) {
		return null;
	}

	return null;
}

export function grantGoogleConsent() {
	storeGoogleConsent(true);
	return updateGoogleConsent(true);
}

export function denyGoogleConsent() {
	storeGoogleConsent(false);
	return updateGoogleConsent(false);
}

export function initializeGoogleConsent() {
	const storedConsent = getStoredGoogleConsent();
	if (storedConsent === null) return false;

	return updateGoogleConsent(storedConsent);
}
